<jw-modal id='addCallbackModal'>
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  <h1 class='header'>Add Callback</h1>

  <div class='form-group col-md-4'>
    <label>Calendar</label>
    <select (change)='this.calendarId = +$event.target.value' [class.is-invalid]='this.calendarId === -1' class='form-control'>
      <option value='-1'>Select a calendar</option>
      @for (calendar of this.calendars; track calendar) {
        <option [value]='calendar.id'>{{ calendar.name }}</option>
      }
    </select>
  </div>

  <div class='form-group col-md-4'>
    <label>Callback Date</label>
    <input [class.is-invalid]='!this.date' type='date' class='form-control' [(ngModel)]='this.date'/>
  </div>
  <div class='form-group col-md-4'>
    <label>Description</label>
    <textarea [class.is-invalid]='!this.description' type='date' class='form-control' [(ngModel)]='this.description'></textarea>
  </div>


  <button class='btn btn-success' (click)='save()'>Save</button>&nbsp;
  <button class='btn btn-danger' (click)='close()'>Cancel</button>
</jw-modal>
